module.exports = __webpack_public_path__ + "images/emoji/clock9.026e8f506ba641fdd622.png";